import React from "react"
import { AppBulkEditAction } from "@components"
import { useUserSettingsSitesGroup, useUserSettingsSitesGroupValidator} from "../../@hooks"


export default function UserSettingSitesGroupDrawerSubmit() {
    const { isLoading, handleSubmitSitesGroupFormData } = useUserSettingsSitesGroup()
    const { isValid } = useUserSettingsSitesGroupValidator()

    return <AppBulkEditAction
        loading={isLoading}
        disabled={!isValid}
        onClick={handleSubmitSitesGroupFormData}
    >
        Save
    </AppBulkEditAction>
}